import { render } from "./ChannelManager.vue?vue&type=template&id=005647ca"
import script from "./ChannelManager.vue?vue&type=script&lang=js"
export * from "./ChannelManager.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__